import { Link } from 'react-router-dom';
import {
  FavoriteFilled as FavoriteFilledIcon,
  FavoriteOutlined as FavoriteOutlinedIcon,
} from '@vgno/icons';

import { AssetThumbnail } from '../../../Asset/AssetThumbnail';
import { getPath, routeNames } from '../../../../shared/helpers/routes';
import { useVendor } from '../../../VendorPovider/VendorPovider';
import { isSvpAsset } from '../../../../modules/helpers';
import { mapItemToType } from '../../../../helpers/favourites';

import type { ImageSources } from '../../../../helpers/images';
import type {
  SvpCategoryAdditional,
  SvpCategoryId,
} from '@vgtv/api-client/lib/svp_category';
import type {
  SvpAssetAdditional,
  SvpAssetId,
} from '@vgtv/api-client/lib/svp_asset';
import type { VFC } from 'react';

import * as styles from './ItemHorizontal.module.scss';

interface Props {
  item: SvpCategoryAdditional | SvpAssetAdditional;
  title: string;
  imageSources?: ImageSources;
  handleIconClick: (
    id: SvpCategoryId | SvpAssetId,
    type: 'asset' | 'category'
  ) => void;
  isFilled: boolean;
}

export const ItemHorizontal: VFC<Props> = (props) => {
  const { title, item, imageSources, handleIconClick, isFilled } = props;
  const { vendor } = useVendor();
  const icon = isFilled ? <FavoriteFilledIcon /> : <FavoriteOutlinedIcon />;

  let targetUrl: string | undefined;
  if (item) {
    targetUrl = isSvpAsset(item)
      ? getPath(routeNames.asset, {
          asset: item,
        })
      : getPath(routeNames.category, {
          category: item,
          vendor,
        });
  }

  return (
    <div className={styles.asset}>
      <div className={styles.thumbnailWrapper}>
        {targetUrl && (
          <Link to={targetUrl}>
            <AssetThumbnail imageSources={imageSources} />
          </Link>
        )}
      </div>

      <div className={styles.info}>
        <div className={styles.title}>
          <div>{title}</div>
          <button onClick={() => handleIconClick(item.id, mapItemToType(item))}>
            {icon}
          </button>
        </div>
      </div>
    </div>
  );
};
